/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics providers — Google Analytics for understanding usage patterns.`)
};

const es_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores de análisis — Google Analytics para entender patrones de uso.`)
};

const de_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseanbieter — Google Analytics zum Verständnis von Nutzungsmustern.`)
};

const nl_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseproviders — Google Analytics om gebruikspatronen te begrijpen.`)
};

const fr_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseurs d’analyse — Google Analytics pour comprendre les habitudes d’utilisation.`)
};

const it_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitori di analisi — Google Analytics per la comprensione dei modelli di utilizzo.`)
};

const pt_br2_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedores de análise — Google Analytics para compreensão de padrões de uso.`)
};

const pt_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecedores de análise — Google Analytics para compreender padrões de utilização.`)
};

const ja_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析プロバイダー — 利用パターンを理解するためのGoogle Analytics。`)
};

const zh_privacy_third_party_analytics = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析提供商 — Google Analytics用于了解使用模式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_third_party_analytics = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_third_party_analytics(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_third_party_analytics", locale)
	if (locale === "en") return en_privacy_third_party_analytics(inputs)
	if (locale === "es") return es_privacy_third_party_analytics(inputs)
	if (locale === "de") return de_privacy_third_party_analytics(inputs)
	if (locale === "nl") return nl_privacy_third_party_analytics(inputs)
	if (locale === "fr") return fr_privacy_third_party_analytics(inputs)
	if (locale === "it") return it_privacy_third_party_analytics(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_third_party_analytics(inputs)
	if (locale === "pt") return pt_privacy_third_party_analytics(inputs)
	if (locale === "ja") return ja_privacy_third_party_analytics(inputs)
	return zh_privacy_third_party_analytics(inputs)
};